/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetAllocation } from './AssetAllocation';
import {
    AssetAllocationFromJSON,
    AssetAllocationFromJSONTyped,
    AssetAllocationToJSON,
} from './AssetAllocation';

/**
 * 
 * @export
 * @interface AssetAllocationPage
 */
export interface AssetAllocationPage {
    /**
     * 
     * @type {Array<AssetAllocation>}
     * @memberof AssetAllocationPage
     */
    assetAllocations: Array<AssetAllocation>;
    /**
     * 
     * @type {number}
     * @memberof AssetAllocationPage
     */
    totalNr: number;
}

/**
 * Check if a given object implements the AssetAllocationPage interface.
 */
export function instanceOfAssetAllocationPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetAllocations" in value;
    isInstance = isInstance && "totalNr" in value;

    return isInstance;
}

export function AssetAllocationPageFromJSON(json: any): AssetAllocationPage {
    return AssetAllocationPageFromJSONTyped(json, false);
}

export function AssetAllocationPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocationPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetAllocations': ((json['asset_allocations'] as Array<any>).map(AssetAllocationFromJSON)),
        'totalNr': json['total_nr'],
    };
}

export function AssetAllocationPageToJSON(value?: AssetAllocationPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset_allocations': ((value.assetAllocations as Array<any>).map(AssetAllocationToJSON)),
        'total_nr': value.totalNr,
    };
}

